import React from 'react';
import {
    Box,
    Typography,
    Alert,
    Button,
    List,
    ListItem,
    ListItemText,
} from '@mui/material';
import { format } from 'date-fns';
import { findDateGaps } from '../../utils/dateUtils';

function VerifyExperience({ employmentHistory, unemploymentHistory, onNext, onBack }) {
    const gaps = findDateGaps(employmentHistory, unemploymentHistory);

    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', p: 3 }}>
            <Typography variant="h6" gutterBottom>Experience Verification</Typography>

            {gaps.length > 0 ? (
                <>
                    <Alert severity="warning" sx={{ mb: 2 }}>
                        We found gaps in your employment history. Please go back and add any missing periods:
                    </Alert>
                    <List>
                        {gaps.map((gap, index) => (
                            <ListItem key={index}>
                                <ListItemText
                                    primary={`Gap found between: ${format(gap.start, 'MMM dd, yyyy')} - ${format(gap.end, 'MMM dd, yyyy')}`}
                                />
                            </ListItem>
                        ))}
                    </List>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onBack}
                        fullWidth
                    >
                        Go Back and Fix Gaps
                    </Button>
                </>
            ) : (
                <>
                    <Alert severity="success" sx={{ mb: 2 }}>
                        Your employment history successfully covers the last 5 years.
                    </Alert>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onNext}
                        fullWidth
                    >
                        Continue
                    </Button>
                </>
            )}
        </Box>
    );
}

export default VerifyExperience;
